import { render, staticRenderFns } from "./confirm-account.vue?vue&type=template&id=113660f1&scoped=true&"
import script from "./confirm-account.ts?vue&type=script&lang=ts&"
export * from "./confirm-account.ts?vue&type=script&lang=ts&"
import style0 from "./confirm-account.scss?vue&type=style&index=0&id=113660f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113660f1",
  null
  
)

export default component.exports